export default __webpack_public_path__ + "static/media/Luggage Moving.b73e49aa.jpg";